import { useEffect, useRef } from "react";

const usePolling = ({ intervalMs, callback, enabled = true }) => {
   const callbackRef = useRef(callback);

   // refresh ref each render so the interval always invokes the freshest callback
   useEffect(() => {
      callbackRef.current = callback;
   });

   useEffect(() => {
      if (!enabled || !intervalMs) return undefined;
      const id = setInterval(() => callbackRef.current?.(), intervalMs);
      return () => clearInterval(id);
   }, [enabled, intervalMs]);
};

export default usePolling;
